import { Injectable } from '@angular/core';
import { defaultConfig, FuseConfigService } from '@keeps-platform-frontend-workspace/layout';
import { WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _workspaceService: WorkspaceService,
  ) {}

  changeThemeColor(colorTheme: string, isDark = false): void {
    const themeColor = colorTheme || defaultConfig.themeColor;
    this._fuseConfigService.config = { themeColor, scheme: isDark ? 'dark' : 'light' };
    this.updateWorkspaceThemeColor(themeColor, isDark);
  }

  private updateWorkspaceThemeColor(custom_color: string, theme_dark: boolean): void {
    const currentWorkspace = this._workspaceService.getCurrentWorkspace();
    this._workspaceService.setCurrentWorkspace({
      ...currentWorkspace,
      custom_color,
      theme_dark,
      created_date: currentWorkspace?.created_date || '',
      id: currentWorkspace?.id || '',
      logo_url: currentWorkspace?.logo_url || '',
      name: currentWorkspace?.name || '',
      status: currentWorkspace?.status || false,
    });
  }
}
